import { ajaxInstance } from "../utils/axios";


export default function useReport() {
  let createReportUrl = `api/txreports/`;

  const getAllReports = (month, year) => {
    return new Promise((resolve, reject) => {
      ajaxInstance
        .get(`${createReportUrl}${year}/${month}`, {
          responseType: "arraybuffer",
          timeout: 120000,
        })
        .then((response) => {
          var arrayBuffer = response.data;
          if (arrayBuffer) {
            var byteArray = new Uint8Array(arrayBuffer);
            for (var i = 0; i < byteArray.byteLength; i++) {
              // do something with each byte in the array
            }
          }
          const url = window.URL.createObjectURL(new Blob([arrayBuffer], {type: response.headers["content-type"]}));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `ib_report_${year}_${month}.zip`); //or any other extension
          document.body.appendChild(link);
          link.click();
          resolve(true)
        })
        .catch((error) => {
          if (error.response.status !== 500) {
            const data = error.response.data;
            const errors = data.errors;
            console.log("Error in get reportHook", errors);
            reject(errors);
          } else {
            console.log("Error in get reportHook", error);
            reject();
          }
        });
    });
  };

  const getSpecificReport = (ib_number, month, year) => {
    return new Promise((resolve, reject) => {
      ajaxInstance
        .get(`${createReportUrl}${ib_number}/${year}/${month}`, {
          timeout: 120000,
        })
        .then((response) => {
          const data = response.data;
          console.log("Get reportHook", data.data);
          if (response.status === 200) {
            resolve(data.data);
          }
        })
        .catch((error) => {
          if (error.response.status !== 500) {
            const data = error.response.data;
            const errors = data.errors;
            console.log("Error in get reportHook", errors);
            reject(errors);
          } else {
            console.log("Error in get reportHook", error);
            reject();
          }
        });
    });
  };

  return {
    getAllReports,
    getSpecificReport,
  };
}
